import { Injectable } from '@angular/core';
//import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { HttpRequest, HttpHandler, HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { NbDialogService, NbToastrService, NbGlobalPhysicalPosition, NbComponentStatus } from '@nebular/theme';
import { ConfirmDialogComponent } from '../shared/components/confirm-dialog/confirm-dialog.component';

@Injectable()
export class AlertDialogService {

  constructor(private dialogService: NbDialogService, public http: HttpClient, private toastrService: NbToastrService) {
  }

  openDialog(header?: string, content?: string, btnLeft?: string, btnRight?: string) {
    if (btnLeft == null || btnLeft == undefined) {
      btnLeft = 'Hủy';
    }
    if (btnRight == null || btnRight == undefined) {
      btnRight = 'Xác nhận';
    }
    return this.dialogService.open(ConfirmDialogComponent, {
      context: {
        header: header,
        content: content,
        btnLeft: btnLeft,
        btnRight: btnRight,
      }, hasBackdrop: true, closeOnEsc: true, closeOnBackdropClick: false
    })


  }
  //status: 'primary' | 'success' | 'warning' | 'danger' | 'info'
  showToast(msg: string, title?: string, status?: NbComponentStatus) {
    if (status == undefined || status == null) {
      status = 'danger';
    }
    this.toastrService.show(msg, title,
      {
        position: NbGlobalPhysicalPosition.BOTTOM_RIGHT, status: status,
        preventDuplicates: false, hasIcon: false
      })
  }

  async openDialogOK(header?: string, content?: string, btnLeft?: string, btnRight?: string) {
    return new Promise(async (resolve) => {
      if (btnRight == null || btnRight == undefined) {
        btnRight = 'OK';
      }
      return this.dialogService.open(ConfirmDialogComponent, {
        context: {
          header: header,
          content: content,
          btnLeft: null,
          btnRight: btnRight,
        }, hasBackdrop: true, closeOnEsc: true, closeOnBackdropClick: false
      }).onClose.subscribe(() => {
        return resolve(true);
      })
    });
  }
}
